// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatingsCell_wrapper__JQEYJ","emptyRatingsBar":"RatingsCell_emptyRatingsBar__e23__"};